import {LEAGUES} from '../constants/leagues';

/**
 * Числовая сила лиги для расчета рейтинга (см. server/utils/rating/calculateRatingChanges).
 * Используется ТОЛЬКО эта дискретная шкала — абсолютный рейтинг внутри лиги
 * на силу игрока не влияет: игрок с рейтингом 501 и 1499 (оба Silver) считаются
 * одинаково сильными.
 */
export const LEAGUE_STRENGTH_BY_ID = {
  [LEAGUES.BRONZE]: 0,
  [LEAGUES.SILVER]: 1,
  [LEAGUES.GOLD]: 2,
  [LEAGUES.DIAMOND]: 3,
  [LEAGUES.RUBY]: 4,
  [LEAGUES.GOD]: 5,
};

/**
 * Во сколько раз уменьшается награда за победу на каждую лигу разницы в
 * пользу победителя. Формула (см. calculateRatingChanges.getExpectedScore):
 *
 *   Expected(i, j) = 1 - 0.5 * DECAY^gap   при gap = Skill(i) - Skill(j) >= 0
 *   Expected(i, j) = 0.5 * DECAY^(-gap)    при gap < 0
 *
 * При DECAY = 0.5 и K = RATING_K_BASE = 100 награда за победу над
 * соперником на gap лиг слабее равна 50 * 0.5^gap (50, 25, 12.5, 6.25, 3.125,
 * ...), а награда за победу над соперником на gap лиг сильнее равна
 * 100 - 50 * 0.5^gap (75, 87.5, 93.75, 96.875, ...) — ровно двукратное
 * уменьшение/приближение к 100 на каждую лигу разницы.
 *
 * DECAY должен быть строго между 0 и 1: 0 выключил бы влияние лиги друг на
 * друга полностью (Expected всегда 0 или 1, кроме gap=0), 1 сделал бы лиги
 * совсем не важны (Expected всегда 0.5, как в самой первой версии системы).
 */
export const RATING_LEAGUE_GAP_DECAY = 0.5;

/**
 * Базовый коэффициент K для попарного расчета изменения рейтинга —
 * используется как есть, без зависимости от числа игроков в матче.
 * Требование "чем больше игроков, тем больше потенциальная награда/потеря"
 * (пункт 9) выполняется и без такой зависимости: дельта игрока — это сумма
 * вкладов по (N-1) соперникам, поэтому размах растет с N сам по себе. Именно
 * поэтому это константа: результат для игроков одной лиги совпадает со
 * старой системой (шаг 50 очков за место) при любом N —
 * Delta(p) = K*0.5*(N+1-2p) = 50*(N+1-2p).
 */
export const RATING_K_BASE = 100;


/**
 * Надбавка к изменению рейтинга за каждый рейтинговый матч по лиге игрока ДО
 * матча (см. server/utils/rating/applyLeagueRatingBonus): чем ниже лига, тем
 * больше — новичкам проще набирать рейтинг. Расчет по местам нулевой по сумме,
 * надбавка — единственное, что создает рейтинг «из воздуха», поэтому она
 * небольшая, убывает с лигой и не выдается, если матч закончился полной
 * ничьей всех игроков (так не заработать, ничего не делая). В верхней,
 * божественной, лиге надбавки нет: рейтинг там растет только за места.
 */
export const RATING_LEAGUE_BONUS = {
  [LEAGUES.BRONZE]: 10,
  [LEAGUES.SILVER]: 8,
  [LEAGUES.GOLD]: 6,
  [LEAGUES.DIAMOND]: 4,
  [LEAGUES.RUBY]: 2,
  [LEAGUES.GOD]: 0,
};
